export default __webpack_public_path__ + "static/media/KOD0121-min.213813f1.webp";